/* ============================================
   ANCE Pros - Page JS
   Minimal: accordion + form handling. No animations.
   ============================================ */
(function () {
  'use strict';

  // ---- Accordion ----
  function initAccordions() {
    document.querySelectorAll('.ap-accordion').forEach(function (acc) {
      var single = acc.dataset.single !== 'false'; // default: only one open
      acc.querySelectorAll('.ap-accordion__trigger').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var item = btn.closest('.ap-accordion__item');
          if (!item) return;
          var isOpen = item.getAttribute('data-open') === 'true';
          if (single) {
            acc.querySelectorAll('.ap-accordion__item').forEach(function (i) {
              i.setAttribute('data-open', 'false');
              var t = i.querySelector('.ap-accordion__trigger');
              if (t) t.setAttribute('aria-expanded', 'false');
            });
          }
          item.setAttribute('data-open', isOpen ? 'false' : 'true');
          btn.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
        });
      });
    });
  }

  // ---- Application form (graceful, no backend required) ----
  function initForm() {
    var form = document.querySelector('[data-ance-pros-form]');
    if (!form) return;
    var status = form.querySelector('.ap-form__status');
    var endpoint = form.getAttribute('data-endpoint');

    form.addEventListener('submit', function (e) {
      // If a real endpoint is configured, let the browser submit normally
      // (or override here to use fetch). Otherwise, fake-success the UX.
      if (!endpoint) {
        e.preventDefault();
        if (!form.checkValidity()) {
          form.reportValidity();
          return;
        }
        if (status) {
          status.setAttribute('data-state', 'success');
          status.textContent =
            "Thanks! Your application has been received. Our team will review and get back to you shortly.";
        }
        form.reset();
      }
    });
  }

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  ready(function () {
    initAccordions();
    initForm();
  });
})();
